import YourAccount from '@/views/yourAccount/YourAccount.vue';

export default [
  {
    path: '/yourAccount',
    name: 'yourAccount',
    component: YourAccount
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: () =>
      import(
        /* webpackChunkName: "favorites" */ '@/views/favorites/Favorites.vue'
      )
  },
  {
    path: '/couponsList',
    name: 'couponsList',
    component: () =>
      import(
        /* webpackChunkName: "couponsList" */ '@/views/couponsList/CouponsList.vue'
      )
  },
  {
    path: '/accountSettings',
    name: 'accountSettings',
    component: () =>
      import(
        /* webpackChunkName: "AccountSettings" */ '@/views/yourAccount/accountSettings/AccountSettings.vue'
      )
  },
  {
    path: '/aboutApp',
    name: 'aboutApp',
    component: () =>
      import(
        /* webpackChunkName: "AboutApp" */ '@/views/yourAccount/aboutApp/AboutApp.vue'
      )
  },
  {
    path: '/personalizedRecommendation',
    name: 'personalizedRecommendation',
    component: () =>
      import(
        /* webpackChunkName: "personalizedRecommendation" */ '@/views/yourAccount/personalizedRecommendation/PersonalizedRecommendation.vue'
      )
  },
  {
    path: '/adPreference',
    name: 'adPreference',
    component: () =>
      import(
        /* webpackChunkName: "adPreference" */ '@/views/yourAccount/adPreference/AdPreference.vue'
      )
  },
  {
    path: '/authorizationManagement',
    name: 'authorizationManagement',
    component: () =>
      import(
        /* webpackChunkName: "authorizationManagement" */ '@/views/yourAccount/authorizationManagement/AuthorizationManagement.vue'
      )
  },
  {
    path: '/privacySecurity',
    name: 'privacySecurity',
    component: () =>
      import(
        /* webpackChunkName: "privacySecurity" */ '@/views/yourAccount/privacySecurity/PrivacySecurity.vue'
      )
  },
  {
    path: '/termStatement',
    name: 'termStatement',
    component: () =>
      import(
        /* webpackChunkName: "termStatement" */ '@/views/protocol/Protocol.vue'
      )
  },
  {
    path: '/businessLicense',
    name: 'businessLicense',
    component: () =>
      import(
        /* webpackChunkName: "BusinessLicense" */ '@/views/yourAccount/businessLicense/BusinessLicense.vue'
      )
  },
  {
    path: '/notificationReminder',
    name: 'notificationReminder',
    component: () =>
      import(
        /* webpackChunkName: "notificationReminder" */ '@/views/yourAccount/notificationReminder/NotificationReminder.vue'
      )
  },
  {
    path: '/contactCS',
    name: 'contactCS',
    component: () =>
      import(
        /* webpackChunkName: "contactCS" */ '@/views/yourAccount/contactCS/ContactCS.vue'
      )
  },
  {
    path: '/selectOrder',
    name: 'selectOrder',
    component: () =>
      import(
        /* webpackChunkName: "selectOrder" */ '@/views/yourAccount/contactCS/selectOrder/SelectOrder.vue'
      )
  },
  {
    path: '/amznContactMe',
    name: 'amznContactMe',
    component: () =>
      import(
        /* webpackChunkName: "amznContactMe" */ '@/views/yourAccount/contactCS/amznContactMe/AmznContactMe.vue'
      )
  },
  {
    path: '/messageCenter',
    name: 'messageCenter',
    component: () =>
      import(
        /* webpackChunkName: "messageCenter" */ '@/views/yourAccount/messageCenter/MessageCenter.vue'
      )
  },
  {
    path: '/messageCenter/notificationItem',
    name: 'notificationItem',
    component: () =>
      import(
        /* webpackChunkName: "notificationItem" */ '@/views/yourAccount/messageCenter/notificationItem/NotificationItem.vue'
      )
  },
  {
    path: '/messageCenter/notificationDetailPage/:id',
    name: 'notificationDetailPage',
    component: () =>
      import(
        /* webpackChunkName: "notificationDetailPage" */ '@/views/yourAccount/messageCenter/notificationDetailPage/NotificationDetailPage.vue'
      )
  },
  {
    path: '/getMyData',
    name: 'getMyData',
    component: () =>
      import(
        /* webpackChunkName: "getMyData" */ '@/views/yourAccount/getMyData/GetMyData.vue'
      )
  },
  {
    path: '/selectDesiredData',
    name: 'selectDesiredData',
    component: () =>
      import(
        /* webpackChunkName: "getMyDataSelectReason" */ '@/views/yourAccount/getMyData/SelectDesiredData.vue'
      )
  },
  {
    path: '/sentSuccessfully',
    name: 'sentSuccessfully',
    component: () =>
      import(
        /* webpackChunkName: "sentSuccessfully" */ '@/views/yourAccount/getMyData/SentSuccessfully.vue'
      )
  },
  {
    path: '/downloadData',
    name: 'downloadData',
    component: () =>
      import(
        /* webpackChunkName: "downloadData" */ '@/views/yourAccount/getMyData/DownloadData.vue'
      )
  },
  {
    path: '/deleteAccount',
    name: 'deleteAccount',
    component: () =>
      import(
        /* webpackChunkName: "deleteAccount" */ '@/views/yourAccount/deleteAccount/DeleteAccount.vue'
      )
  },
  {
    path: '/selectReason',
    name: 'selectReason',
    component: () =>
      import(
        /* webpackChunkName: "deleteAccountSelectReason" */ '@/views/yourAccount/deleteAccount/SelectReason.vue'
      )
  },
  {
    path: '/deletionRequestSent',
    name: 'deletionRequestSent',
    component: () =>
      import(
        /* webpackChunkName: "deletionRequestSent" */ '@/views/yourAccount/deleteAccount/DeletionRequestSent.vue'
      )
  },
  {
    path: '/deletionProceeding',
    name: 'deletionProceeding',
    component: () =>
      import(
        /* webpackChunkName: "deletionProceeding" */ '@/views/yourAccount/deleteAccount/DeletionProceeding.vue'
      )
  },
  {
    path: '/intakeACDDTermination',
    name: 'intakeACDDTermination',
    component: () =>
      import(
        /* webpackChunkName: "IntakeACDDTermination" */ '@/views/yourAccount/deleteAccount/IntakeACDDTermination.vue'
      )
  },
  {
    path: '/reviewACDD',
    name: 'reviewACDD',
    component: () =>
      import(
        /* webpackChunkName: "reviewACDD" */ '@/views/yourAccount/deleteAccount/ReviewACDD.vue'
      )
  }
];
